import React from 'react';
import { SFButton, SFIconButton, SFMenu, SFMenuItem } from 'sfui';
import styles from './InitiativeCardActions.module.scss';

export interface InitiativeCardActionsProps {
  isButtonDisabled: boolean;
  onSeeRecentReports: () => void;
}

export const InitiativeCardActions = ({
  isButtonDisabled,
  onSeeRecentReports
}: InitiativeCardActionsProps): React.ReactElement<InitiativeCardActionsProps> => {
  const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<any>();

  const onClick = (e: any) => {
    if (!isMenuOpen) {
      setAnchorEl(e.currentTarget);
      setIsMenuOpen(true);
    }
  };

  return (
    <div className={styles.initiativeCardActions}>
      <div className={styles.actionsMenu}>
        <SFIconButton
          className={styles.btnMenu}
          sfIcon="Other"
          sfSize="medium"
          onClick={onClick}
          aria-label="More Options"
        />

        <SFMenu
          open={isMenuOpen}
          anchorEl={anchorEl}
          onClose={() => setIsMenuOpen(false)}
        >
          <SFMenuItem
            disabled={isButtonDisabled}
            onClick={() => {
              onSeeRecentReports();
              setIsMenuOpen(false);
            }}
          >
            See Recent Reports
          </SFMenuItem>
        </SFMenu>
      </div>

      <div className={styles.actionsButtons}>
        <SFButton
          variant="outlined"
          disabled={isButtonDisabled}
          onClick={onSeeRecentReports}
        >
          See Recent Reports
        </SFButton>
      </div>
    </div>
  );
};
